import { ApiError } from 'services/api';
import * as actionTypes from './actionTypes';
import { ChangeLogEntry, FeatureFlag, UsersByOrganization } from './types';

/*------------------------------------------------------------------------------------------------*/
/* Fetch Users Actions                                                          */
/*------------------------------------------------------------------------------------------------*/
export const fetchUsers = () => {
  return {
    type: actionTypes.FETCH_USERS_REQUEST,
  };
};

export const fetchUsersResponse = (users: UsersByOrganization[]) => {
  return {
    type: actionTypes.FETCH_USERS_RESPONSE,
    users,
  };
};

export const fetchUsersError = (error: ApiError | Error) => {
  return {
    type: actionTypes.FETCH_USERS_ERROR,
    error,
  };
};

/*------------------------------------------------------------------------------------------------*/
/* Fetch Feature Flag Change Log Actions                                                          */
/*------------------------------------------------------------------------------------------------*/
export const fetchChangeLog = (featureFlag: FeatureFlag) => ({
  type: actionTypes.FETCH_CHANGE_LOG,
  fetchingChangeLog: true,
  featureFlag,
});

export const fetchChangeLogError = (error: ApiError | Error) => ({
  type: actionTypes.FETCH_CHANGE_LOG_ERROR,
  fetchingChangeLog: false,
  error,
});

export const fetchChangeLogResponse = (changeLog: ChangeLogEntry[]) => ({
  type: actionTypes.FETCH_CHANGE_LOG_RESPONSE,
  fetchingChangeLog: false,
  changeLog,
});

/*------------------------------------------------------------------------------------------------*/
/* Fetch Feature Flags Actions                                                                    */
/*------------------------------------------------------------------------------------------------*/
export const fetchFeatureFlags = () => ({
  type: actionTypes.FETCH_FEATURE_FLAGS,
  fetching: true,
});

export const fetchFeatureFlagsError = (error: ApiError | Error) => ({
  type: actionTypes.FETCH_FEATURE_FLAGS_ERROR,
  fetching: false,
  error,
});

export const fetchFeatureFlagsResponse = (featureFlags: FeatureFlag[]) => ({
  type: actionTypes.FETCH_FEATURE_FLAGS_RESPONSE,
  fetching: false,
  featureFlags,
});

/*------------------------------------------------------------------------------------------------*/
/* Save Feature Flag Actions                                                                      */
/*------------------------------------------------------------------------------------------------*/
export const saveFeatureFlag = (featureFlag: FeatureFlag, comment: string) => ({
  type: actionTypes.SAVE_FEATURE_FLAG,
  featureFlag,
  comment,
});

export const saveFeatureFlagError = (error: ApiError | Error) => ({
  type: actionTypes.SAVE_FEATURE_FLAG_ERROR,
  error,
});
